import lifecycle from 'recompose/lifecycle';
import { withFormik } from 'formik';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import Formats from './Formats';
import { getFormats } from './helpers';
import withProductCustomisation from '../../../hocs/withProductCustomisation';
import {
  trackFormatDrawerOpenTab,
  trackFormatDrawerCloseTab,
} from 'src/client/js/analytics/category/product';

const enhance = compose(
  withProductCustomisation,
  withFormik({
    mapPropsToValues: props => ({
      format_identifier: props.productCustomisation.format_identifier,
    }),
  }),
  withProps(props => ({
    formats: getFormats(props),
  })),
  lifecycle({
    componentDidMount() {
      trackFormatDrawerOpenTab();
    },
    componentWillUnmount() {
      trackFormatDrawerCloseTab();
    }
  })
);

export default enhance(Formats);
